import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

// TODO
// export interface ConfigState {
// }

export default new Vuex.Store({
    state: {
        // url to your proxy page, must be on same machine hosting you app. See proxy folder for readme.
        proxy: {
            // url: 'https://remaxproxy-dev.azurewebsites.net/proxy.ashx',
            url: 'https://proxy.remaxnova.com/proxy.ashx',
        },

        mobileLinks: {
            ios: 'https://apps.apple.com/us/app/remap/id6443455631',
            android: 'https://play.google.com/store/apps/details?id=com.remaxnova.remap',
        },

        imageRoot: 'https://data.remaxnova.com/propimages/',
        gMapUrl: 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAn-0SRNJTThntgtl7lQubiY9mGCMcvvKc',
        gMapAPIKey: 'AIzaSyAn-0SRNJTThntgtl7lQubiY9mGCMcvvKc',
        googleMarkerUrl: 'https://data.remaxnova.com/propimages/map/pins/res.png',
        placeholdListingImg: 'placeholder-listing.png',
        baseUrl: 'https://remaxdev.azureedge.net',
        baseFullListingUrl: 'https://remaxnova.com/',

        // url to your geometry server.
        geometryService: {
            url: 'https://tasks.arcgisonline.com/ArcGIS/rest/services/Geometry/GeometryServer',
        },

        searchBounds: [[43.530209, -66.431514], [47.477872, -59.647943]],

        highlightedListingColor: {
            color: '#34DDDD',
            weight: 3,
        },

        mapDefault: {
            basemap: 'Streets',
            center: [44.662143, -63.597600],
            zoom: 13,
            maxBounds: [[42.4, -67.6], [47.7, -58.4]],
            minZoom: 7,
            maxZoom: 19,
        },
        locationTimeout: 10000, // ms
        locationZoom: 15,
        locationColor: '#DC1C2E',
        locationSize: 10,
        mapBoxToken: 'pk.eyJ1Ijoia3Bvd2VyIiwiYSI6ImNrZ3p0bGltZjE2djkydG4wd2tkOXBpemYifQ.XsGmMaDmBa7E1jCGVI4Z5A',
        basemapLayers: {
            MapBox: {
                name: 'MapBox',
                label: 'Streets (New!)',
                options: {
                    maxZoom: 19,
                },
                // style: 'mapbox://styles/mapbox/light-v10',
                style: 'mapbox://styles/mapbox/streets-v11',
                thumbnail: 'https://data.remaxnova.com/propimages/map/layers/mapbox-streets.png',
                active: false,
            },
            Streets: {
                name: 'Streets',
                label: 'Streets',
                thumbnail: 'https://data.remaxnova.com/propimages/map/layers/street.jpg',
                active: false,
            },
            Gray: {
                name: 'Gray',
                label: 'Gray',
                thumbnail: 'https://data.remaxnova.com/propimages/map/layers/gray.jpg',
                active: false,
            },
            Topographic: {
                name: 'Topographic',
                label: 'Topographic',
                thumbnail: 'https://data.remaxnova.com/propimages/map/layers/topo.jpg',
                active: false,
            },
            Imagery_Bing: {
                name: 'Imagery_Bing',
                label: 'Satellite (Bing)',
                thumbnail: 'https://data.remaxnova.com/propimages/map/layers/sat.jpg',
                active: false,
                key: 'Ar1wtMyCAMh4mqjglcASyG6_62YgoaLX4s2nBdxOO4fT7xB66HWWi4Db6J_t7TEy',
                type: 'Aerial',
            },
            Imagery: {
                name: 'Imagery',
                label: 'Satellite (ArcGIS)',
                thumbnail: 'https://data.remaxnova.com/propimages/map/layers/sat.jpg',
                active: false,
            },
            Imagery_GeoNova: {
                name: 'Imagery_GeoNova',
                url: 'https://nsgiwa.novascotia.ca/arcgis/rest/services/BASE/BASE_NSODB_10k_WM84/MapServer',
                options: {
                    maxZoom: 19,
                },
                label: 'Satellite (GeoNova)',
                thumbnail: 'https://data.remaxnova.com/propimages/map/layers/sat.jpg',
                active: false,
            },
            OSM: {
                name: 'OSM',
                urlTemplate: 'http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                options: {
                    maxZoom: 19,
                },
                label: 'Open Street Map',
                thumbnail: 'https://data.remaxnova.com/propimages/map/layers/osm.jpg',
                active: false,
            },
        },

        ParcelVectorTileLayer: {
            name: 'Parcel Vector Tiles',
            url: 'https://remaxnova-api.azurewebsites.net/api/featureservice/parcels_tiles',
            styleNormal: {
                // see mapbox style spec https://docs.mapbox.com/mapbox-gl-js/style-spec/root
                version: 8,
                sources: {
                    esri: {
                        type: 'vector',
                        tiles: [
                            'https://remaxnova-api.azurewebsites.net/api/featureservice/parcels_tiles/tile/{z}/{y}/{x}.pbf',
                        ],
                    },
                },
                // layer information comes from this esri URL (un-parsable by MapBoxGL)
                // https://tiles.arcgis.com/tiles/mTfTWCbg7Pb330oT/arcgis/rest/services/parcels_nov_2019/VectorTileServer/resources/styles
                layers: [
                    {
                        'id': 'level 12-15',
                        'source': 'esri',
                        'source-layer': 'level 12-15',
                        'type': 'line',
                        'minzoom': 14,
                        'maxzoom': 16,
                        'layout': {
                            'line-cap': 'round',
                            'line-join': 'round',
                        },
                        'paint': {
                            'line-color': 'rgba(52,52,52,0.5)',
                            'line-width': 0.266667,
                        },
                    }, {
                        'id': 'level 17-19',
                        'type': 'line',
                        'source': 'esri',
                        'source-layer': 'level 17-19',
                        'minzoom': 16,
                        'layout': {
                            'line-cap': 'round',
                            'line-join': 'round',
                        },
                        'paint': {
                            'line-color': 'rgba(52,52,52,0.8)',
                            'line-width': 0.666667,
                        },
                    },
                ],
            },
            styleWhite: {
                // see mapbox style spec https://docs.mapbox.com/mapbox-gl-js/style-spec/root
                version: 8,
                sources: {
                    esri: {
                        type: 'vector',
                        tiles: [
                            'https://remaxnova-api.azurewebsites.net/api/featureservice/parcels_tiles/tile/{z}/{y}/{x}.pbf',
                        ],
                    },
                },
                // layer information comes from this esri URL (un-parsable by MapBoxGL)
                // https://tiles.arcgis.com/tiles/mTfTWCbg7Pb330oT/arcgis/rest/services/parcels_nov_2019/VectorTileServer/resources/styles
                layers: [
                    {
                        'id': 'level 12-15',
                        'source': 'esri',
                        'source-layer': 'level 12-15',
                        'type': 'line',
                        'minzoom': 14,
                        'maxzoom': 16,
                        'layout': {
                            'line-cap': 'round',
                            'line-join': 'round',
                        },
                        'paint': {
                            'line-color': 'rgba(255,255,255,0.5)',
                            'line-width': 0.266667,
                        },
                    }, {
                        'id': 'level 17-19',
                        'type': 'line',
                        'source': 'esri',
                        'source-layer': 'level 17-19',
                        'minzoom': 16,
                        'layout': {
                            'line-cap': 'round',
                            'line-join': 'round',
                        },
                        'paint': {
                            'line-color': 'rgba(255,255,255,0.8)',
                            'line-width': 0.666667,
                        },
                    },
                ],
            },
        },

        DALayer: {
            name: 'Disemination Areas',
            url: 'https://services2.arcgis.com/mTfTWCbg7Pb330oT/arcgis/rest/services/DisseminationAreas/FeatureServer/0',
        },

        ParcelsLayer: {
            name: 'Parcels',
            url: 'https://remaxnova-api.azurewebsites.net/api/featureservice/parcels_ro',
            minZoom: 19,
            maxZoom: 20,
            definitionExpression: '',
            simplifyFactor: 0.80,
            precision: 5,
        },

        ListingsPointLayer: {
            name: 'Parcel Listing Points',
            url: 'https://remaxnova-api.azurewebsites.net/api/featureservice/ListingPnt_ro_ex',
            url_in: 'https://remaxnova-api.azurewebsites.net/api/featureservice/ListingPnt_ro_ex',
            minZoom: 7,
            maxZoom: 20,
            precision: 5,
            outFields: ['*'],
            definitionExpression: `st like '%1%' or st like '%3%'`,
            thumbnail: 'https://data.remaxnova.com/propimages/map/layers/listings.jpg',
            label: 'Listing Points',
            tooltip: 'Price labels for active/sold lisings',
            active: true,
            isVisible: true,
        },

        HeatmapLayer: {
            name: 'heatmap',
            thumbnail: 'https://data.remaxnova.com/propimages/map/layers/heatmap.jpg',
            label: 'SOLD Heatmap',
            tooltip: 'Properties SOLD in the last year',
            active: false,
        },

        ListingsPolygonLayer: {
            name: 'Parcel Listing Polygons',
            url: 'https://remaxnova-api.azurewebsites.net/api/featureservice/ListingPly_ro_ex',
            url_in: 'https://remaxnova-api.azurewebsites.net/api/featureservice/ListingPly_ro_ex',
            minZoom: 15,
            maxZoom: 20,
            // DO NOT remove OBJECTID
            outFields: ['OBJECTID', 'sid', 'mli', 'mlan', 'tlan', 'lls', 'bdmn', 'bhmn', 'st', 'fd', 'ld', 'ad', 'cm', 'pc', 'lpmn', 'sp', 'ml', 'md', 'cl', 'pi', 'pid', 'br'],
            definitionExpression: '',
            simplifyFactor: 0.65,
            precision: 5,
        },

        CrimeRecordsTable: {
            name: 'Crime Records Table',
            url: 'https://services2.arcgis.com/mTfTWCbg7Pb330oT/ArcGIS/rest/services/HRM_Crimes/FeatureServer/1',
        },

        CrimeRecordsLayer: {
            name: 'Crime Records Layer',
            url: 'https://services2.arcgis.com/mTfTWCbg7Pb330oT/ArcGIS/rest/services/HRM_Crimes_ro/FeatureServer/0',
            thumbnail: 'https://data.remaxnova.com/propimages/map/pins/crime_legend.png',
            label: 'HRM Crime',
            tooltip: 'Crimes from Nov 6, 2017 - present. Updated weekly. The information about the event itself is accurate; however the location information is purposefully generic. The location of the crime points is generalized using a methodology that places it at the mid-point of the nearest street segment. Contains information licenced under the Open Government Licence—Halifax (https://www.halifax.ca/home/open-data/open-data-license)',
            active: false,
        },

        BuildingPermitLayer: {
            name: 'Permit Layer',
            minZoom: 17,
            maxZoom: 20,
            url: 'https://services2.arcgis.com/mTfTWCbg7Pb330oT/arcgis/rest/services/HRM_Permits_ro/FeatureServer/0',
        },

        SchoolCatchmentLayer: {
            name: 'School Layer',
            url: 'https://services2.arcgis.com/mTfTWCbg7Pb330oT/ArcGIS/rest/services/Schools/FeatureServer/1',
        },

        CrownLandLayer: {
            name: 'Crown Land Layer',
            url: 'https://nsgiwa.novascotia.ca/arcgis/rest/services/PLAN/PLANCrownLandsWM84V1/MapServer/0',
            minZoom: 14,
            maxZoom: 20,
            tooltip: 'Crown Land within Nova Scotia',
            label: 'Crown Land',
            thumbnail: 'https://data.remaxnova.com/propimages/map/layers/crownlands.png',
            active: false,
        },
        ForeignBuyerBanLayer: {
            name: 'Foreign Buyer Ban Layer',
            url: 'https://data.remaxnova.com/map/foreign-buyers.json',
            minZoom: 8,
            maxZoom: 20,
            tooltip: 'Foreign Buyer Ban Areas',
            label: 'Foreign Buyer Ban',
            thumbnail: 'https://data.remaxnova.com/propimages/map/layers/foreign-buyer.png',
            active: false,
        },

        FilterOptions: {
            PriceNoMinVal: 0,
            PriceNoMaxVal: 99999999,
            PriceMinOptions: [
                { step: 0, value: 0, label: 'No Min' },
                { step: 1, value: 25000, label: '$25K' },
                { step: 2, value: 50000, label: '$50K' },
                { step: 3, value: 75000, label: '$75K' },
                { step: 4, value: 100000, label: '$100K' },
                { step: 5, value: 125000, label: '$125K' },
                { step: 6, value: 150000, label: '$150K' },
                { step: 7, value: 175000, label: '$175K' },
                { step: 8, value: 200000, label: '$200K' },
                { step: 9, value: 225000, label: '$225K' },
                { step: 10, value: 250000, label: '$250K' },
                { step: 11, value: 275000, label: '$275K' },
                { step: 12, value: 300000, label: '$300K' },
                { step: 13, value: 325000, label: '$325K' },
                { step: 14, value: 350000, label: '$350K' },
                { step: 15, value: 375000, label: '$375K' },
                { step: 16, value: 400000, label: '$400K' },
                { step: 17, value: 425000, label: '$425K' },
                { step: 18, value: 450000, label: '$450K' },
                { step: 19, value: 475000, label: '$475K' },
                { step: 20, value: 500000, label: '$500K' },
                { step: 21, value: 550000, label: '$550K' },
                { step: 22, value: 600000, label: '$600K' },
                { step: 23, value: 650000, label: '$650K' },
                { step: 24, value: 700000, label: '$700K' },
                { step: 25, value: 750000, label: '$750K' },
                { step: 26, value: 800000, label: '$800K' },
                { step: 27, value: 850000, label: '$850K' },
                { step: 28, value: 900000, label: '$900K' },
                { step: 29, value: 950000, label: '$950K' },
                { step: 30, value: 1000000, label: '$1M' },
                { step: 31, value: 1500000, label: '$1.5M' },
                { step: 32, value: 2000000, label: '$2M' },
                { step: 33, value: 2500000, label: '$2.5M' },
                { step: 34, value: 3000000, label: '$3M' },
                { step: 35, value: 3500000, label: '$3.5M' },
                { step: 36, value: 4000000, label: '$4M' },
                { step: 37, value: 4500000, label: '$4.5M' },
                { step: 38, value: 5000000, label: '$5M' },
                { step: 39, value: 5500000, label: '$5.5M' },
                { step: 40, value: 6000000, label: '$6M' },
                { step: 41, value: 6500000, label: '$6.5M' },
                { step: 42, value: 7000000, label: '$7M' },
                { step: 43, value: 7500000, label: '$7.5M' },
                { step: 44, value: 8000000, label: '$8M' },
                { step: 45, value: 8500000, label: '$8.5M' },
                { step: 46, value: 9000000, label: '$9M' },
                { step: 47, value: 9500000, label: '$9.5M' },
                { step: 48, value: 10000000, label: '$10M' },
                { step: 49, value: 99999999, label: 'No Max' },
            ],
            PriceMaxOptions: [
                { step: 0, value: 0, label: 'No Min' },
                { step: 1, value: 25000, label: '$25K' },
                { step: 2, value: 50000, label: '$50K' },
                { step: 3, value: 75000, label: '$75K' },
                { step: 4, value: 100000, label: '$100K' },
                { step: 5, value: 125000, label: '$125K' },
                { step: 6, value: 150000, label: '$150K' },
                { step: 7, value: 175000, label: '$175K' },
                { step: 8, value: 200000, label: '$200K' },
                { step: 9, value: 225000, label: '$225K' },
                { step: 10, value: 250000, label: '$250K' },
                { step: 11, value: 275000, label: '$275K' },
                { step: 12, value: 300000, label: '$300K' },
                { step: 13, value: 325000, label: '$325K' },
                { step: 14, value: 350000, label: '$350K' },
                { step: 15, value: 375000, label: '$375K' },
                { step: 16, value: 400000, label: '$400K' },
                { step: 17, value: 425000, label: '$425K' },
                { step: 18, value: 450000, label: '$450K' },
                { step: 19, value: 475000, label: '$475K' },
                { step: 20, value: 500000, label: '$500K' },
                { step: 21, value: 550000, label: '$550K' },
                { step: 22, value: 600000, label: '$600K' },
                { step: 23, value: 650000, label: '$650K' },
                { step: 24, value: 700000, label: '$700K' },
                { step: 25, value: 750000, label: '$750K' },
                { step: 26, value: 800000, label: '$800K' },
                { step: 27, value: 850000, label: '$850K' },
                { step: 28, value: 900000, label: '$900K' },
                { step: 29, value: 950000, label: '$950K' },
                { step: 30, value: 1000000, label: '$1M' },
                { step: 31, value: 1500000, label: '$1.5M' },
                { step: 32, value: 2000000, label: '$2M' },
                { step: 33, value: 2500000, label: '$2.5M' },
                { step: 34, value: 3000000, label: '$3M' },
                { step: 35, value: 3500000, label: '$3.5M' },
                { step: 36, value: 4000000, label: '$4M' },
                { step: 37, value: 4500000, label: '$4.5M' },
                { step: 38, value: 5000000, label: '$5M' },
                { step: 39, value: 5500000, label: '$5.5M' },
                { step: 40, value: 6000000, label: '$6M' },
                { step: 41, value: 6500000, label: '$6.5M' },
                { step: 42, value: 7000000, label: '$7M' },
                { step: 43, value: 7500000, label: '$7.5M' },
                { step: 44, value: 8000000, label: '$8M' },
                { step: 45, value: 8500000, label: '$8.5M' },
                { step: 46, value: 9000000, label: '$9M' },
                { step: 47, value: 9500000, label: '$9.5M' },
                { step: 48, value: 10000000, label: '$10M' },
                { step: 49, value: 99999999, label: 'No Max' },
            ],

            BedNoMinVal: 0,
            BedNoMaxVal: 99,
            BedMinOptions: [
                { value: 0, label: 'No Min' },
                { value: 1, label: '1' },
                { value: 2, label: '2' },
                { value: 3, label: '3' },
                { value: 4, label: '4' },
                { value: 5, label: '5' },
                { value: 6, label: '6' },
                { value: 7, label: '7' },
                { value: 8, label: '8' },
                { value: 9, label: '9' },
                { value: 10, label: '10' },
            ],
            BedMaxOptions: [
                { value: 99, label: 'No Max' },
                { value: 1, label: '1' },
                { value: 2, label: '2' },
                { value: 3, label: '3' },
                { value: 4, label: '4' },
                { value: 5, label: '5' },
                { value: 6, label: '6' },
                { value: 7, label: '7' },
                { value: 8, label: '8' },
                { value: 9, label: '9' },
                { value: 10, label: '10' },
            ],
            BathNoMinVal: 0,
            BathNoMaxVal: 99,
            BathMinOptions: [
                { value: 0, label: 'No Min' },
                { value: 1, label: '1' },
                { value: 2, label: '2' },
                { value: 3, label: '3' },
                { value: 4, label: '4' },
                { value: 5, label: '5' },
                { value: 6, label: '6' },
                { value: 7, label: '7' },
                { value: 8, label: '8' },
                { value: 9, label: '9' },
                { value: 10, label: '10' },
            ],
            BathMaxOptions: [
                { value: 99, label: 'No Max' },
                { value: 1, label: '1' },
                { value: 2, label: '2' },
                { value: 3, label: '3' },
                { value: 4, label: '4' },
                { value: 5, label: '5' },
                { value: 6, label: '6' },
                { value: 7, label: '7' },
                { value: 8, label: '8' },
                { value: 9, label: '9' },
                { value: 10, label: '10' },
            ],
            ClassOptions: [
                { value: '1', label: 'Residential' },
                { value: '2', label: 'Commercial' },
                { value: '3', label: 'Multi-Unit' },
                { value: '4', label: 'Farm' },
                { value: '5', label: 'Vacant Land' },
            ],
            ResidentialTypeOptions: [
                { value: '0', label: 'Single Family' },
                { value: '1', label: 'Condominium' },
                { value: '2', label: 'Mobile / Mini' },
                { value: '3', label: 'Cottage / Rec. Properties' },
                { value: '4', label: 'Duplex' },
                { value: '5', label: 'Other' },
                { value: '25', label: 'Co-Op' },
                { value: '28', label: 'Apartment' },
            ],
            CommercialTypeOptions: [
                { value: '6', label: 'Commercial Retail' },
                { value: '7', label: 'Commercial Condo' },
                { value: '8', label: 'Industrial' },
                { value: '9', label: 'Institutional' },
                { value: '10', label: 'Other' },
                { value: '24', label: 'Business Only' },
                { value: '26', label: 'Office' },
                { value: '27', label: 'Business' },
            ],
            MultiTypeOptions: [
                { value: '11', label: 'Duplex' },
                { value: '12', label: 'Triplex' },
                { value: '13', label: 'Fourplex' },
                { value: '14', label: '5-8 Units' },
                { value: '17', label: 'Other' },
                { value: '15', label: '9-12 Units' },
                { value: '16', label: 'Over 12 Units' },
            ],
            FarmTypeOptions: [
                { value: '18', label: 'No Building Onsite' },
                { value: '19', label: 'Single Family' },
                { value: '20', label: 'Mobile/Mini' },
                { value: '21', label: 'Other' },
            ],
            VacantLandTypeOptions: [
                { value: '22', label: 'Vacant Lot(s)' },
                { value: '23', label: 'Acreage' },
            ],
            StyleOptions: [
                { value: 'BARELAND', label: 'Bareland' },
                { value: 'CAMP', label: 'Camp' },
                { value: 'CAPRT', label: 'Condo Apartment' },
                { value: 'CTWNH', label: 'Condo Townhouse' },
                { value: 'DTCHD', label: 'Detached' },
                { value: 'FREEHOLD', label: 'Freehold' },
                { value: 'LEASEHOLD', label: 'Leasehold' },
                { value: 'LINK', label: 'Link' },
                { value: 'MINI', label: 'Mini' },
                { value: 'MOBILE', label: 'Mobile' },
                { value: 'None', label: 'None' },
                { value: 'OTHER', label: 'Other' },
                { value: 'RECREATNAL', label: 'Recreational' },
                { value: 'RESIDENTL', label: 'Residential' },
                { value: 'SDTCH', label: 'Semi-Detached' },
                { value: 'TWNHS', label: 'Townhouse' },
                { value: 'APARTMENT', label: 'Apartment' },
                { value: 'OVER', label: 'Over-Under' },
                { value: 'SBS', label: 'Side By Side' },
                { value: 'BB', label: 'B & B' },
            ],
            HeatTypeOptions: [
                { label: 'Window Cooling', value: '1436' },
                { label: 'None', value: '105' },
                { label: 'Other', value: '104' },
                { label: 'Stove', value: '103' },
                { label: 'Space Heater', value: '102' },
                { label: 'Radiator', value: '1278' },
                { label: 'Radiant', value: '101' },
                { label: 'In Floor', value: '100' },
                { label: 'Hot Water', value: '99' },
                { label: 'Heat Pump -Ductless', value: '98' },
                { label: 'Heat Pump -Ducted', value: '97' },
                { label: 'Furnace', value: '95' },
                { label: 'Forced Air', value: '94' },
                { label: 'Fireplace', value: '93' },
                { label: 'ETS (Elec Therm Storage)', value: '92' },
                { label: 'Ductless Cooling', value: '1435' },
                { label: 'Ducted Cooling', value: '91' },
                { label: 'Baseboard', value: '90' },
                { label: 'None', value: '460' },
                { label: 'Other', value: '459' },
                { label: 'Stove', value: '458' },
                { label: 'Space Heater', value: '457' },
                { label: 'Radiator', value: '1279' },
                { label: 'Radiant', value: '456' },
                { label: 'In Floor', value: '455' },
                { label: 'Hot Water', value: '454' },
                { label: 'Heat Pump -Ductless', value: '453' },
                { label: 'Heat Pump -Ducted', value: '452' },
                { label: 'Furnace', value: '450' },
                { label: 'Forced Air', value: '449' },
                { label: 'Fireplace', value: '448' },
                { label: 'ETS (Elec Therm Storage)', value: '447' },
                { label: 'Central Air', value: '446' },
                { label: 'Baseboard', value: '445' },
                { label: 'Window Cooling', value: '1442' },
                { label: 'None', value: '955' },
                { label: 'Other', value: '954' },
                { label: 'Stove', value: '953' },
                { label: 'Space Heater', value: '952' },
                { label: 'Radiator', value: '1281' },
                { label: 'Radiant', value: '951' },
                { label: 'In Floor', value: '950' },
                { label: 'Hot Water', value: '949' },
                { label: 'Heat Pump -Ductless', value: '948' },
                { label: 'Heat Pump -Ducted', value: '947' },
                { label: 'Furnace', value: '945' },
                { label: 'Forced Air', value: '944' },
                { label: 'Fireplace', value: '943' },
                { label: 'ETS (Elec Therm Storage)', value: '942' },
                { label: 'Ductless Cooling', value: '1443' },
                { label: 'Ducted Cooling', value: '941' },
                { label: 'Baseboard', value: '940' },
                { label: 'Window Cooling', value: '1439' },
                { label: 'None', value: '632' },
                { label: 'Other', value: '631' },
                { label: 'Stove', value: '630' },
                { label: 'Space Heater', value: '629' },
                { label: 'Radiator', value: '1280' },
                { label: 'Radiant', value: '628' },
                { label: 'In Floor', value: '627' },
                { label: 'Hot Water', value: '626' },
                { label: 'Heat Pump -Ductless', value: '625' },
                { label: 'Heat Pump -Ducted', value: '624' },
                { label: 'Furnace', value: '622' },
                { label: 'Forced Air', value: '621' },
                { label: 'Fireplace', value: '620' },
                { label: 'ETS (Elec Therm Storage)', value: '619' },
                { label: 'Ductless Cooling', value: '1441' },
                { label: 'Ducted Cooling', value: '618' },
                { label: 'Baseboard', value: '617' },
            ],
            StatusOptions: [
                { label: '<span class="selectFORSALE">For Sale</span>', value: '1' },
                { label: '<span class="selectSOLD">Sold</span> (past 6 months)', value: '2' },
                { label: '<span class="selectPENDING">Pending</span>', value: '3' },
            ],
            MlaNoMinVal: 0,
            MlaNoMaxVal: 99999,
            MlaMinOptions: [
                { value: '0', label: 'No min' },
                { value: '500', label: '500' },
                { value: '750', label: '750' },
                { value: '1000', label: '1,000' },
                { value: '1250', label: '1,250' },
                { value: '1500', label: '1,500' },
                { value: '1750', label: '1,750' },
                { value: '2000', label: '2,000' },
                { value: '2250', label: '2,250' },
                { value: '2500', label: '2,500' },
                { value: '2750', label: '2,750' },
                { value: '3000', label: '3,000' },
                { value: '3500', label: '3,500' },
                { value: '4000', label: '4,000' },
                { value: '5000', label: '5,000' },
                { value: '7500', label: '7,500' },
            ],
            MlaMaxOptions: [
                { value: '99999', label: 'No Max' },
                { value: '500', label: '500' },
                { value: '750', label: '750' },
                { value: '1000', label: '1,000' },
                { value: '1250', label: '1,250' },
                { value: '1500', label: '1,500' },
                { value: '1750', label: '1,750' },
                { value: '2000', label: '2,000' },
                { value: '2250', label: '2,250' },
                { value: '2500', label: '2,500' },
                { value: '2750', label: '2,750' },
                { value: '3000', label: '3,000' },
                { value: '3500', label: '3,500' },
                { value: '4000', label: '4,000' },
                { value: '5000', label: '5,000' },
                { value: '7500', label: '7,500' },
            ],
            TlaNoMinVal: 0,
            TlaNoMaxVal: 99999,
            TlaMinOptions: [
                { value: '0', label: 'No min' },
                { value: '500', label: '500' },
                { value: '750', label: '750' },
                { value: '1000', label: '1,000' },
                { value: '1250', label: '1,250' },
                { value: '1500', label: '1,500' },
                { value: '1750', label: '1,750' },
                { value: '2000', label: '2,000' },
                { value: '2250', label: '2,250' },
                { value: '2500', label: '2,500' },
                { value: '2750', label: '2,750' },
                { value: '3000', label: '3,000' },
                { value: '3500', label: '3,500' },
                { value: '4000', label: '4,000' },
                { value: '5000', label: '5,000' },
                { value: '7500', label: '7,500' },
            ],
            TlaMaxOptions: [
                { value: '99999', label: 'No Max' },
                { value: '500', label: '500' },
                { value: '750', label: '750' },
                { value: '1000', label: '1,000' },
                { value: '1250', label: '1,250' },
                { value: '1500', label: '1,500' },
                { value: '1750', label: '1,750' },
                { value: '2000', label: '2,000' },
                { value: '2250', label: '2,250' },
                { value: '2500', label: '2,500' },
                { value: '2750', label: '2,750' },
                { value: '3000', label: '3,000' },
                { value: '3500', label: '3,500' },
                { value: '4000', label: '4,000' },
                { value: '5000', label: '5,000' },
                { value: '7500', label: '7,500' },
            ],
            AgeNoMinVal: 0,
            AgeNoMaxVal: 999,
            AgeMinOptions: [
                { value: '0', label: 'No Min' },
                { value: '1', label: '1' },
                { value: '2', label: '2' },
                { value: '3', label: '3' },
                { value: '5', label: '5' },
                { value: '10', label: '10' },
                { value: '15', label: '15' },
                { value: '20', label: '20' },
                { value: '25', label: '25' },
                { value: '35', label: '35' },
                { value: '45', label: '45' },
                { value: '55', label: '55' },
                { value: '65', label: '65' },
                { value: '75', label: '75' },
                { value: '100', label: '100' },
            ],
            AgeMaxOptions: [
                { value: '999', label: 'No Max' },
                { value: '1', label: '1' },
                { value: '2', label: '2' },
                { value: '3', label: '3' },
                { value: '5', label: '5' },
                { value: '10', label: '10' },
                { value: '15', label: '15' },
                { value: '20', label: '20' },
                { value: '25', label: '25' },
                { value: '35', label: '35' },
                { value: '45', label: '45' },
                { value: '55', label: '55' },
                { value: '65', label: '65' },
                { value: '75', label: '75' },
                { value: '100', label: '100' },
            ],
            LotSizeNoMinVal: 0,
            LotSizeNoMaxVal: 99999999,
            LotSizeMinOptions: [
                { step: 0, value: 0, label: 'No Min' },
                { step: 1, value: 2000, label: '2,000 sq ft' },
                { step: 2, value: 4500, label: '4,500 sq ft' },
                { step: 3, value: 6500, label: '6,500 sq ft' },
                { step: 4, value: 8000, label: '8,000 sq ft' },
                { step: 5, value: 10890, label: '10,890 sq ft / .25 acres' },
                { step: 6, value: 21780, label: '21,780 sq ft / .5 acres' },
                { step: 7, value: 43560, label: '1 acre' },
                { step: 8, value: 87120, label: '2 acres' },
                { step: 9, value: 130680, label: '3 acres' },
                { step: 10, value: 174240, label: '4 acres' },
                { step: 11, value: 217800, label: '5 acres' },
                { step: 12, value: 435600, label: '10 acres' },
                { step: 13, value: 1742400, label: '40 acres' },
                { step: 14, value: 4356000, label: '100 acres' },
                { step: 15, value: 99999999, label: 'No Max' },
            ],
            LotSizeMaxOptions: [
                { step: 0, value: 0, label: 'No Min' },
                { step: 1, value: 2000, label: '2,000 sq ft' },
                { step: 2, value: 4500, label: '4,500 sq ft' },
                { step: 3, value: 6500, label: '6,500 sq ft' },
                { step: 4, value: 8000, label: '8,000 sq ft' },
                { step: 5, value: 10890, label: '10,890 sq ft / .25 acres' },
                { step: 6, value: 21780, label: '21,780 sq ft / .5 acres' },
                { step: 7, value: 43560, label: '1 acre' },
                { step: 8, value: 87120, label: '2 acres' },
                { step: 9, value: 130680, label: '3 acres' },
                { step: 10, value: 174240, label: '4 acres' },
                { step: 11, value: 217800, label: '5 acres' },
                { step: 12, value: 435600, label: '10 acres' },
                { step: 13, value: 1742400, label: '40 acres' },
                { step: 14, value: 4356000, label: '100 acress' },
                { step: 15, value: 99999999, label: 'No Max' },
            ],

            SchoolOptions: [
                { label: '- no school selected -', value: '0' },
                { label: 'A. J. Smeltzer Junior High School (English, Grade 7 - 9)', value: '175' },
                { label: 'A. J. Smeltzer Junior High School (Late French, Grade 7 - 9)', value: '176' },
                { label: 'Admiral Westphal Elementary School (English, Grade P - 6)', value: '73' },
                { label: 'Alderney School (English, Grade P - 6)', value: '74' },
                { label: 'Ash-Lee Jefferson Elementary School (Early French, Grade P - 6)', value: '131' },
                { label: 'Ash-Lee Jefferson Elementary School (English, Grade P - 6)', value: '132' },
                { label: 'Astral Drive Elementary School (English, Grade P - 6)', value: '37' },
                { label: 'Astral Drive Junior High School (English, Grade 7 - 9)', value: '33' },
                { label: 'Astral Drive Junior High School (Late French, Grade 7 - 9)', value: '34' },
                { label: 'Atlantic Memorial - Terence Bay Elementary (Atlantic Memorial) School (English, Grade P - 6)', value: '213' },
                { label: 'Atlantic Memorial - Terence Bay Elementary (Terence Bay) School (English, Grade P - 6)', value: '202' },
                { label: 'Atlantic View School (English, Grade P - 6)', value: '17' },
                { label: 'Auburn Drive High School (Early French, Grade 10 - 12)', value: '38' },
                { label: 'Auburn Drive High School (English, Grade 10 - 12)', value: '41' },
                { label: 'Auburn Drive High School (Late French, Grade 10 - 12)', value: '43' },
                { label: 'Basinview Drive Community School (English, Grade P - 6)', value: '183' },
                { label: 'Beaver Bank-Kinsac Elementary School (English, Grade P - 6)', value: '189' },
                { label: 'Beaver Bank-Monarch Drive Elementary School (English, Grade P - 6)', value: '184' },
                { label: 'Bedford South School (English, Grade P - 6)', value: '182' },
                { label: 'Beechville-Lakeside-Timberlea Jr School (Early French, Grade P - 2)', value: '209' },
                { label: 'Beechville-Lakeside-Timberlea Jr School (English, Grade P - 2)', value: '210' },
                { label: 'Beechville-Lakeside-Timberlea Sr School (Early French, Grade 3 - 6)', value: '207' },
                { label: 'Beechville-Lakeside-Timberlea Sr School (English, Grade 3 - 6)', value: '208' },
                { label: 'Bel Ayr School (English, Grade P - 6)', value: '58' },
                { label: 'Bell Park Academic Centre (Early French, Grade P - 6)', value: '18' },
                { label: 'Bell Park Academic Centre (English, Grade P - 6)', value: '19' },
                { label: 'Bicentennial School (English, Grade 7 - 9)', value: '84' },
                { label: 'Bicentennial School (English, Grade P - 6)', value: '83' },
                { label: 'Brookhouse School (English, Grade P - 6)', value: '66' },
                { label: 'Brookside Junior High School (English, Grade 7 - 9)', value: '205' },
                { label: 'Brookside Junior High School (Late French, Grade 7 - 9)', value: '206' },
                { label: 'Burton Ettinger School (Early French, Grade P - 6)', value: '145' },
                { label: 'Burton Ettinger School (English, Grade P - 6)', value: '146' },
                { label: 'Caldwell Road Elementary School (English, Grade P - 6)', value: '52' },
                { label: 'Caledonia Junior High School (English, Grade 7 - 9)', value: '68' },
                { label: 'Caledonia Junior High School (Late French, Grade 7 - 9)', value: '69' },
                { label: 'Caudle Park Elementary School (English, Grade P - 6)', value: '163' },
                { label: 'Cavalier Drive Elementary-Junior High School (Early French, Grade P - 6)', value: '166' },
                { label: 'Cavalier Drive Elementary-Junior High School (English, Grade P - 6)', value: '167' },
                { label: 'Central Spryfield School (English, Grade P - 6)', value: '130' },
                { label: 'Charles P. Allen High School (Early French, Grade 10 - 12)', value: '193' },
                { label: 'Charles P. Allen High School (English, Grade 10 - 12)', value: '194' },
                { label: 'Charles P. Allen High School (Late French, Grade 10 - 12)', value: '195' },
                { label: 'Chebucto Heights Elementary School (Early French, Grade P - 6)', value: '140' },
                { label: 'Chebucto Heights Elementary School (Early French, Grade P - 6)', value: '141' },
                { label: 'Chebucto Heights Elementary School (English, Grade P - 6)', value: '142' },
                { label: 'Citadel High School (Early French, Grade 10 - 12)', value: '93' },
                { label: 'Citadel High School (English, Grade 10 - 12)', value: '94' },
                { label: 'Clayton Park Junior High School (English, Grade 7 - 9)', value: '150' },
                { label: 'Colby Village Elementary School (English, Grade P - 6)', value: '45' },
                { label: 'Cole Harbour District High School (Early French, Grade 10 - 12)', value: '47' },
                { label: 'Cole Harbour District High School (English, Grade 10 - 12)', value: '48' },
                { label: 'Cole Harbour District High School (English, Grade 10 - 12)', value: '49' },
                { label: 'Cole Harbour District High School (Late French, Grade 10 - 12)', value: '50' },
                { label: 'Colonel John Stuart Elementary School (English, Grade P - 6)', value: '36' },
                { label: 'Crichton Park School (English, Grade P - 6)', value: '81' },
                { label: 'Cunard Junior High School (English, Grade 7 - 9)', value: '112' },
                { label: 'Dartmouth High School (Early French, Grade 10 - 12)', value: '86' },
                { label: 'Dartmouth High School (Late French, Grade 10 - 12)', value: '88' },
                { label: 'Duc D\'Anville Elementary School (English, Grade P - 6)', value: '151' },
                { label: 'Duncan Macmillan High School (English, Grade 10 - 12)', value: '2' },
                { label: 'Duncan Macmillan High School (English, Grade 7 - 9)', value: '1' },
                { label: 'Dutch Settlement Elementary School (English, Grade P - 6)', value: '20' },
                { label: 'East St. Margaret\'s Elementary School (English, Grade P - 6)', value: '227' },
                { label: 'Eastern Passage Education Centre (Early French, Grade 7 - 9)', value: '24' },
                { label: 'Eastern Passage Education Centre (English, Grade 7 - 9)', value: '25' },
                { label: 'Eastern Passage Education Centre (Late French, Grade 7 - 9)', value: '26' },
                { label: 'Eastern Shore District High School (English, Grade 10 - 12)', value: '11' },
                { label: 'Eastern Shore District High School (Late French, Grade 10 - 12)', value: '12' },
                { label: 'Elizabeth Sutherland School (Early French, Grade 10 - 12)', value: '134' },
                { label: 'Elizabeth Sutherland School (Early French, Grade 7 - 9)', value: '133' },
                { label: 'Elizabeth Sutherland School (English, Grade 7 - 9)', value: '136' },
                { label: 'Elizabeth Sutherland School (English, Grade P - 6)', value: '135' },
                { label: 'Ellenvale Junior High School (English, Grade 7 - 9)', value: '64' },
                { label: 'Ellenvale Junior High School (Late French, Grade 7 - 9)', value: '65' },
                { label: 'Eric Graves Memorial Junior High School (English, Grade 7 - 9)', value: '59' },
                { label: 'Fairview Heights School (Annex Building) (English, Grade P - 2)', value: '152' },
                { label: 'Fairview Heights School (Main Building) (English, Grade 3 - 6)', value: '158' },
                { label: 'Fairview Junior High School (Early French, Grade 10 - 12)', value: '156' },
                { label: 'Fairview Junior High School (Early French, Grade 7 - 9)', value: '155' },
                { label: 'Fairview Junior High School (English, Grade 7 - 9)', value: '157' },
                { label: 'Five Bridges Junior High School (Early French, Grade 7 - 9)', value: '219' },
                { label: 'Five Bridges Junior High School (English, Grade 7 - 9)', value: '220' },
                { label: 'Five Bridges Junior High School (Late French, Grade 7 - 9)', value: '221' },
                { label: 'Gaetz Brook Junior High School (English, Grade 7 - 9)', value: '13' },
                { label: 'Gaetz Brook Junior High School (Late French, Grade 7 - 9)', value: '14' },
                { label: 'George Bissett Elementary School (English, Grade P - 6)', value: '46' },
                { label: 'Georges P. Vanier Junior High School (Early French, Grade 7 - 9)', value: '127' },
                { label: 'Georges P. Vanier Junior High School (English, Grade 7 - 9)', value: '128' },
                { label: 'Georges P. Vanier Junior High School (Late French, Grade 7 - 9)', value: '129' },
                { label: 'Gorsebrook Junior High School (Early French, Grade 7 - 9)', value: '91' },
                { label: 'Gorsebrook Junior High School (English, Grade 7 - 9)', value: '92' },
                { label: 'Graham Creighton Junior High School (Early French, Grade 7 - 9)', value: '29' },
                { label: 'Graham Creighton Junior High School (English, Grade 7 - 9)', value: '30' },
                { label: 'Graham Creighton Junior High School (Late French, Grade 7 - 9)', value: '31' },
                { label: 'Grosvenor-Wentworth Park Elementary School (Early French, Grade P - 6)', value: '173' },
                { label: 'Grosvenor-Wentworth Park Elementary School (English, Grade P - 6)', value: '174' },
                { label: 'Halifax Central Junior High (English, Grade 7 - 9)', value: '100' },
                { label: 'Halifax West High School (English, Grade 10 - 12)', value: '168' },
                { label: 'Halifax West High School (Late French, Grade 10 - 12)', value: '170' },
                { label: 'Hammonds Plains Consolidated School (Early French, Grade P - 6)', value: '214' },
                { label: 'Hammonds Plains Consolidated School (English, Grade P - 6)', value: '215' },
                { label: 'Harbour View School (English, Grade P - 6)', value: '96' },
                { label: 'Harold T. Barrett Junior High School (English, Grade 7 - 9)', value: '190' },
                { label: 'Harold T. Barrett Junior High School (Late French, Grade 7 - 9)', value: '191' },
                { label: 'Harrietsfield Elementary School (English, Grade P - 6)', value: '143' },
                { label: 'Harry R. Hamilton School (English, Grade P - 6)', value: '203' },
                { label: 'Hawthorn School (English, Grade P - 6)', value: '77' },
                { label: 'Herring Cove Junior High School (English, Grade 7 - 9)', value: '79' },
                { label: 'Herring Cove Junior High School (Late French, Grade 7 - 9)', value: '80' },
                { label: 'Highland Park Junior High School (English, Grade 7 - 9)', value: '116' },
                { label: 'Hillside Park Elementary School (English, Grade P - 6)', value: '164' },
                { label: 'Holland Road Elementary School (English, Grade P - 6)', value: '104' },
                { label: 'Humber Park Elementary School (English, Grade P - 6)', value: '54' },
                { label: 'Ian Forsyth School (English, Grade P - 6)', value: '70' },
                { label: 'J. L. Ilsley High School (English, Grade 10 - 12)', value: '114' },
                { label: 'J. L. Ilsley High School (Late French, Grade 10 - 12)', value: '115' },
                { label: 'John MacNeil School (English, Grade P - 6)', value: '90' },
                { label: 'John Martin Junior High School (English, Grade 7 - 9)', value: '95' },
                { label: 'John W. MacLeod - Fleming Tower School (Fleming Tower) (Early French, Grade P - 6)', value: '120' },
                { label: 'John W. MacLeod - Fleming Tower School (Fleming Tower) (English, Grade P - 6)', value: '121' },
                { label: 'John W. MacLeod - Fleming Tower School (John W. MacLeod) (Early French, Grade P - 6)', value: '117' },
                { label: 'John W. MacLeod - Fleming Tower School (John W. MacLeod) (English, Grade P - 6)', value: '118' },
                { label: 'Joseph Giles Elementary School (English, Grade P - 6)', value: '53' },
                { label: 'Joseph Howe School (English, Grade P - 6)', value: '97' },
                { label: 'Kingswood Elementary School (Early French, Grade P - 6)', value: '211' },
                { label: 'Kingswood Elementary School (English, Grade P - 6)', value: '212' },
                { label: 'Lakefront Consolidated Elementary School (English, Grade P - 6)', value: '3' },
                { label: 'LeMarchant-St. Thomas School (Early French, Grade P - 6)', value: '98' },
                { label: 'LeMarchant-St. Thomas School (English, Grade P - 6)', value: '99' },
                { label: 'Leslie Thomas Junior High School (Early French, Grade 7 - 9)', value: '177' },
                { label: 'Leslie Thomas Junior High School (English, Grade 7 - 9)', value: '178' },
                { label: 'Leslie Thomas Junior High School (Late French, Grade 7 - 9)', value: '179' },
                { label: 'Lockview High School (English, Grade 10 - 12)', value: '138' },
                { label: 'Lockview High School (Late French, Grade 10 - 12)', value: '139' },
                { label: 'Madeline Symonds Middle School (Early French, Grade 7 - 9)', value: '216' },
                { label: 'Madeline Symonds Middle School (English, Grade 7 - 9)', value: '217' },
                { label: 'Madeline Symonds Middle School (Late French, Grade 7 - 9)', value: '218' },
                { label: 'Michael Wallace School (English, Grade P - 6)', value: '76' },
                { label: 'Millwood Elementary School (English, Grade P - 6)', value: '198' },
                { label: 'Millwood High School (English, Grade 10 - 12)', value: '199' },
                { label: 'Millwood High School (Late French, Grade 10 - 12)', value: '200' },
                { label: 'Mount Edward School (English, Grade P - 6)', value: '62' },
                { label: 'Musquodoboit Rural High School (English, Grade 10 - 12)', value: '9' },
                { label: 'Musquodoboit Rural High School (English, Grade 7 - 9)', value: '8' },
                { label: 'Musquodoboit Valley Education Centre (English, Grade P - 6)', value: '10' },
                { label: 'Nelson Whynder Elementary School (English, Grade P - 6)', value: '27' },
                { label: 'O\'Connell Drive Elementary (English, Grade P - 6)', value: '16' },
                { label: 'Ocean View Elementary School (English, Grade P - 6)', value: '32' },
                { label: 'Oldfield Consolidated School (English, Grade P - 6)', value: '72' },
                { label: 'Oxford School (Early French, Grade 7 - 9)', value: '106' },
                { label: 'Oxford School (English, Grade 7 - 9)', value: '108' },
                { label: 'Oxford School (English, Grade P - 6)', value: '107' },
                { label: 'Oyster Pond Academy (English, Grade 7 - 9)', value: '6' },
                { label: 'Oyster Pond Academy (English, Grade P - 6)', value: '5' },
                { label: 'Oyster Pond Academy (Late French, Grade 7 - 9)', value: '7' },
                { label: 'Park West School (English, Grade 7 - 9)', value: '172' },
                { label: 'Park West School (English, Grade P - 6)', value: '171' },
                { label: 'Porters Lake Elementary School (English, Grade P - 6)', value: '15' },
                { label: 'Portland Estates School (English, Grade P - 6)', value: '61' },
                { label: 'Prince Andrew High School (English, Grade 10 - 12)', value: '67' },
                { label: 'Prospect Road Elementary School (English, Grade P - 6)', value: '204' },
                { label: 'Ridgecliff Middle School (Early French, Grade 7 - 9)', value: '186' },
                { label: 'Ridgecliff Middle School (English, Grade 7 - 9)', value: '187' },
                { label: 'Ridgecliff Middle School (Late French, Grade 7 - 9)', value: '188' },
                { label: 'Robert K. Turner Elementary School (English, Grade P - 6)', value: '55' },
                { label: 'Rockingham School (Early French, Grade P - 6)', value: '159' },
                { label: 'Rockingham School (English, Grade P - 6)', value: '160' },
                { label: 'Rockingstone Heights School (English, Grade 7 - 9)', value: '126' },
                { label: 'Rockingstone Heights School (English, Grade P - 6)', value: '125' },
                { label: 'Rocky Lake Junior High School (Early French, Grade 7 - 9)', value: '147' },
                { label: 'Rocky Lake Junior High School (English, Grade 7 - 9)', value: '148' },
                { label: 'Rocky Lake Junior High School (Late French, Grade 7 - 9)', value: '149' },
                { label: 'Ross Road School (English, Grade 7 - 9)', value: '22' },
                { label: 'Ross Road School (English, Grade P - 6)', value: '21' },
                { label: 'Ross Road School (Late French, Grade 7 - 9)', value: '23' },
                { label: 'Sackville Heights Elementary School (English, Grade P - 6)', value: '201' },
                { label: 'Sackville Heights Junior High School (English, Grade 7 - 9)', value: '196' },
                { label: 'Sackville Heights Junior High School (Late French, Grade 7 - 9)', value: '197' },
                { label: 'Sackville High School (English, Grade 10 - 12)', value: '180' },
                { label: 'Sackville High School (Late French, Grade 10 - 12)', value: '181' },
                { label: 'Saint Mary\'s School (English, Grade P - 6)', value: '89' },
                { label: 'Sambro Elementary School (English, Grade P - 6)', value: '113' },
                { label: 'Seaside Elementary School (Early French, Grade P - 6)', value: '28' },
                { label: 'Shannon Park School (Early French, Grade P - 6)', value: '109' },
                { label: 'Shannon Park School (English, Grade P - 6)', value: '111' },
                { label: 'Shatford Memorial Elementary School (English, Grade P - 6)', value: '228' },
                { label: 'Sir Charles Tupper School (English, Grade P - 6)', value: '105' },
                { label: 'Sir John A. Macdonald High School (English, Grade 10 - 12)', value: '222' },
                { label: 'Sir Robert Borden Junior High School (English, Grade 7 - 9)', value: '56' },
                { label: 'Sir Robert Borden Junior High School (Late French, Grade 7 - 9)', value: '57' },
                { label: 'Smokey Drive Elementary School (English, Grade P - 6)', value: '192' },
                { label: 'South Woodside School (English, Grade P - 6)', value: '71' },
                { label: 'Southdale-North Woodside School (English, Grade P - 6)', value: '75' },
                { label: 'Springvale School (English, Grade P - 6)', value: '144' },
                { label: 'St. Agnes School (English, Grade 7 - 9)', value: '137' },
                { label: 'St. Catherine\'s School (Early French, Grade P - 6)', value: '122' },
                { label: 'St. Catherine\'s School (English, Grade P - 6)', value: '123' },
                { label: 'St. Joseph\'s-Alexander McKay School (Early French, Grade P - 6)', value: '101' },
                { label: 'St. Joseph\'s-Alexander McKay School (English, Grade P - 6)', value: '102' },
                { label: 'St. Margaret\'s Bay Elementary School (English, Grade P - 6)', value: '226' },
                { label: 'St. Stephen\'s School (English, Grade P - 6)', value: '119' },
                { label: 'Sunnyside Elementary School (Eaglewood Drive) (Early French, Grade P - 6)', value: '153' },
                { label: 'Sunnyside Elementary School (Eaglewood Drive) (English, Grade P - 6)', value: '154' },
                { label: 'Sunnyside Elementary School (Fort Sackville) (Early French, Grade P - 6)', value: '161' },
                { label: 'Sunnyside Elementary School (Fort Sackville) (English, Grade P - 6)', value: '162' },
                { label: 'Sycamore Lane Elementary School (English, Grade P - 6)', value: '185' },
                { label: 'Tallahassee Community School (English, Grade P - 6)', value: '35' },
                { label: 'Tantallon Junior Elementary School (Early French, Grade P - 2)', value: '223' },
                { label: 'Tantallon Junior Elementary School (English, Grade P - 2)', value: '224' },
                { label: 'Tantallon Senior Elementary School (English, Grade 3 - 6)', value: '225' },
                { label: 'Upper Musquodoboit Consolidated School (English, Grade P - 6)', value: '4' },
                { label: 'Waverley Memorial Elementary School (English, Grade P - 6)', value: '103' },
                { label: 'Westmount School (English, Grade P - 6)', value: '124' },
                { label: 'William King Elementary School (English, Grade P - 6)', value: '78' },
            ],
        },
        operationalLayers: [],

    },
    mutations: {
    },
    actions: {
    },
});
